const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Integral medica",
    description: "150g",
    priceWithoutDiscount: "90.00$",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_integralmedica_150g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Max Titanium",
    description: "100g",
    priceWithoutDiscount: "90.00$",
    quantity: "1",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_100g_max_titanium.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Integral medica",
    description: "300g",
    priceWithoutDiscount: "90.00$",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_integralmedica_300g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Max Titanium",
    description: "300g",
    priceWithoutDiscount: "90.00$",
    quantity: "11",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_300g_max_titanium.png"),
  },
];

export default ProducsData;
